import { IVec3, Vec3 } from "@base/math/Vec3";
import { ImmHelper } from "@base/util/Immutable";
import { PropertyNamesWithType } from "@base/util/TypeUtil";
import { ILineAlign, ITexInfo } from "@biz/definitions/SunSailDefinitions";
import { IWallCornerProps, IWallData } from "@biz/items/wall/WallDefinitions";
import { WallHelper } from "@biz/items/wall/WallHelper";
import { getItemLayerReducers } from "@biz/reducers/ItemLayerReducer";

export const WallReducer = {
  ...getItemLayerReducers<IWallData>(),
  setHeight(old: IWallData, v: number): IWallData {
    return { ...old, height: v }
  },
  setWidth(old: IWallData, v: number): IWallData {
    return { ...old, width: v }
  },
  setAlignWidth(old: IWallData, alignWidth: ILineAlign): IWallData {
    return { ...old, alignWidth }
  },
  setSectorLength(old: IWallData, pointIndex: number, length: number,): IWallData {
    const las = WallHelper.calcLengthAngles(old.corners);
    las[pointIndex].length = length;
    return ImmHelper.setProperty(old, "corners", WallHelper.calcCornersFromLengthAndAngles(las, old.corners[0]))
  },
  setSectorAngle(old: IWallData, pointIndex: number, radAngle: number): IWallData {
    const las = WallHelper.calcLengthAngles(old.corners);
    las[pointIndex].angle = radAngle;
    return ImmHelper.setProperty(old, "corners", WallHelper.calcCornersFromLengthAndAngles(las, old.corners[0]))
  },
  setHeightOffset(old: IWallData, pointIndex: number, type: PropertyNamesWithType<IWallCornerProps, number | undefined>, offset: number | undefined): IWallData {
    return {
      ...old,
      cornerProps: ImmHelper.setArrayItem(old.cornerProps || [], pointIndex, {
        ...old.cornerProps?.[pointIndex],
        [type]: offset
      })
    }

  },
  setCorner(old: IWallData, index: number, p: IVec3): IWallData {
    return {
      ...old,
      corners: ImmHelper.setArrayItem(old.corners, index, p)
    }
  },
  setNiveau(old: IWallData, niveau: number): IWallData {
    return {
      ...old,
      corners: old.corners.map((c) => ImmHelper.setProperty(c, "y", niveau))
    }
  },
  setCorners(old: IWallData, points: IVec3[]): IWallData {
    return {
      ...old,
      corners: points
    }
  },
  addCorner(old: IWallData, index: number, p?: IVec3): IWallData {
    if (!p) {
      if (index < 0) {
        p = Vec3.addScaled(old.corners[0], Vec3.to(old.corners[1], old.corners[0]), 1.0);
      } else if (index < old.corners.length - 1)
        p = Vec3.mid(old.corners[index], old.corners[index + 1]);
      else {
        index = old.corners.length - 1;
        p = Vec3.addScaled(old.corners[index], Vec3.to(old.corners[index - 1], old.corners[index]), 1.0);
      }
    }
    return {
      ...old,
      corners: ImmHelper.insertArrayItem(old.corners, index + 1, p),
      cornerProps: ImmHelper.insertArrayItem(old.cornerProps || [], index + 1, {})
    }
  },
  removeCorner(old: IWallData, index: number, _p?: IVec3): IWallData {
    return {
      ...old,
      corners: ImmHelper.removeArrayItem(old.corners, index),
      cornerProps: ImmHelper.removeArrayItem(old.cornerProps || [], index)
    }
  },
  setTexInfo(old: IWallData, texInfo: ITexInfo): IWallData {
    return {
      ...old,
      texInfo
    }
  }
}